import { EEvents } from 'src/types/events';

/**
 * Dispatch NODES_CHANGED so the Flow listener runs validateNode and updates
 * node.data.category.isValid and validationErrors. Call after setNodes when
 * node data has been updated.
 */
export function dispatchNodesChanged(nodeIds: string[]): void {
  if (nodeIds.length === 0) return;
  window.dispatchEvent(
    new CustomEvent<{ nodeIds: string[] }>(EEvents.NODES_CHANGED, {
      detail: { nodeIds: [...new Set(nodeIds)] },
    }),
  );
}
